import React, { useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditCMSPageNew from "../../components/CMS/AddCMSPageNew";



const EditCMSPage = () => {
    const [cmsTitle, setCmsTitle] = useState("Edit CMS"); // default until fetched
  
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="CMS" link2="/cms" title="Edit CMS" cmsTitle={cmsTitle} />

        {/* AddUserLayer */}
        <EditCMSPageNew onTitleLoad={(title) => setCmsTitle(title)} />


      </MasterLayout>
    </>
  );
};

export default EditCMSPage;
